import React, { Component } from 'react';
import moment from 'moment';
import axios from 'axios';
import Loading from '../Loading/Loading';
import { Configurations } from '../../Utils/Configurations';
import ErrorModal from '../ErrorModal/ErrorModal';
import IdProducts from '../IdProducts/IdProducts';
import ReactTable from 'react-table';
import update from 'immutability-helper';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';


class ShippingItemsToAdd extends Component {
    constructor(props) {
        super(props);

        this.handleProductChange = this.handleProductChange.bind(this);
        this.handleShippingCompChange = this.handleShippingCompChange.bind(this);
        this.handleEditionChange = this.handleEditionChange.bind(this);
        this.getSummaryItemsToDeliver = this.getSummaryItemsToDeliver.bind(this);

        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.refreshTable = this.refreshTable.bind(this);
        this.obtemTipoBadge = this.obtemTipoBadge.bind(this);
        this.handleCheck = this.handleCheck.bind(this);
        this.changeAllCheckboxes = this.changeAllCheckboxes.bind(this);
        this.getListaReenvio = this.getListaReenvio.bind(this);
        this.adicionarItemReenvioRemessa = this.adicionarItemReenvioRemessa.bind(this);
        this.toggleModalSucessoAdicionadoRemessa = this.toggleModalSucessoAdicionadoRemessa.bind(this);


        this.Configurations = new Configurations();


        this.state = {
            isLoadingProducts: false,
            isLoadingShippingComp: false,
            isLoadingItemsToAdd: false,
            isLoadingAddingItems: this.props.isLoadingAddingItems,
            products: [],
            productEditions: [],
            shippingCompanies: [],
            itemsToAdd: undefined,
            selectedProduct: undefined,
            selectedEdition: undefined,
            selectedShippingComp: undefined,
            hasError: false,
            errorMessage: '',
            listaReenvio: [],
            modalSucessoAdicionadoRemessa: false,
            dados: [],
            flagReenvio: true
        }


        this.columns = [
            {
                Header: '',
                width: 30,
                className: 'text-center',
                Cell: row => {
                    return (
                        <span>{row.index + 1}</span>
                    )
                }
            },
            {
                Header: '',
                accessor: 'selecionaItem',
                className: 'text-center pointer',
                width: 25,
                Cell: row => <i onClick={(e) => this.handleCheck("selecionaItem", row.index)} className={row.value ? `far fa-check-square fa-lg` : `far fa-square fa-lg`}></i>
            },
            {
                Header: 'Assinante',
                accessor: 'nomeAssinante',
                className: 'text-center pointer',
                width: 300,
            },
            {
                Header: 'Motivo do Reenvio',
                width: 300,
                accessor: "motivoReenvio",
                className: 'text-center pointer',
            },
            {
                Header: 'Transportadora',
                width: 200,
                accessor: "nomeTransportadora",
                className: 'text-center pointer',
            },
            {
                Header: "Produto",
                accessor: 'nomeProduto',
                width: 100,
                className: 'text-center pointer',
                Cell: row => (<span className={`badge badge-${this.obtemTipoBadge(row.original.siglaProduto).badgeColor}`}>{row.original.nomeProduto}</span>)
            },
            {
                Header: 'Edição',
                accessor: 'numeroEdicao',
                className: 'text-center pointer',

            }

        ]
    }
    componentDidMount() {
        if (this.props.flagReenvio) {
            this.getListaReenvio();
        } else {
            this.getShippingCompanies();
            this.getProducts();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.resetProducts !== prevProps.resetProducts) {
            this.setState({
                itemsToAdd: undefined,
                selectedProduct: undefined,
                selectedEdition: undefined,
                selectedShippingComp: undefined
            })
        }
    }

    async getProducts() {
        this.setState({ isLoadingProducts: true })
        const _productsList = axios.get(this.Configurations.apiBasePath + `/logistica/produtos`);

        _productsList.then(response => {
            this.setState({
                products: response.data.produtos
            });
        }).catch(this.handleError).finally(() => this.setState({ isLoadingProducts: false }))
    }

    async getShippingCompanies() {
        this.setState({ isLoadingShippingComp: true })
        const _ShippList = axios.get(this.Configurations.apiBasePath + `/logistica/transportadoras`);

        _ShippList.then(response => {
            this.setState({
                shippingCompanies: response.data.transportadoras
            });
        }).catch(this.handleError).finally(() => this.setState({ isLoadingShippingComp: false }))
    }

    async getSummaryItemsToDeliver() {
        this.setState({ isLoadingItemsToAdd: true })
        const _itemsToDeliverList = axios.get(this.Configurations.apiBasePath + `/logistica/remessa/itens-para-entrega/${this.state.selectedShippingComp}/${this.state.selectedProduct}/${this.state.selectedEdition}`);

        _itemsToDeliverList.then(response => {
            this.setState({
                itemsToAdd: response.data.itensRemessa
            });
        }).catch(this.handleError).finally(() => this.setState({ isLoadingItemsToAdd: false }))
    }

    handleProductChange(e) {
        const _value = parseInt(e.target.value);
        const _product = this.state.products.find(item => item.idProduto === _value)
        let _editions = [];

        if (_product && _product.edicoes) _editions = _product.edicoes;

        const _toUpdate = {
            selectedProduct: _value,
            productEditions: _editions
        }

        if (this.props.onProductChange) this.props.onProductChange(_toUpdate);

        this.setState(_toUpdate);
    }

    handleShippingCompChange(e) {
        const _value = parseInt(e.target.value);
        // const _shipp = this.state.shippingCompanies.find(item => item.idTransportadora === _value)

        const _toUpdate = {
            selectedShippingComp: _value,
        }
        if (this.props.onShippingCompChange) this.props.onShippingCompChange(_toUpdate);

        this.setState(_toUpdate);
    }

    handleEditionChange(e) {
        const _toUpdate = {
            selectedEdition: parseInt(e.target.value)
        };

        if (this.props.onEditionChange) this.props.onEditionChange(_toUpdate);

        this.setState(_toUpdate);
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response ? err.response.data.message : 'Erro inesperado.' })
    }

    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }

    getListaReenvio() {
        this.setState({ isLoadingShippingList: true })

        axios.get(this.Configurations.apiBasePath + `/logistica/reenvio/itens-reenvio`).then(response => {
            this.setState({
                listaReenvio: response.data.itensReenvio
            })
        }).catch(this.handleError).finally(() => this.setState({ isLoadingShippingList: false }))
    }

    refreshTable() {
    }

    obtemTipoBadge(tipo) {

        let _tipoBadge;
        let _textColorInside = 'white';
        let _textColorOutside;

        switch (tipo.toLowerCase()) {
            case "bd":
                _tipoBadge = 'water';
                _textColorOutside = _tipoBadge;
                break;
            case "bm":
                _tipoBadge = 'verde';
                _textColorOutside = _tipoBadge;
                break;
            case "tc":
                _tipoBadge = 'danger';
                _textColorOutside = _tipoBadge;
                break;
            case "rd":
                _tipoBadge = 'warning';
                _textColorOutside = 'info';
                _textColorInside = 'info';
                break;
            case "bj":
                _tipoBadge = 'success';
                _textColorOutside = _tipoBadge;
                break;
            case "da":
                _tipoBadge = 'secondary';
                _textColorOutside = _tipoBadge;
                break;
            default:
                _tipoBadge = 'primary';
                _textColorOutside = _tipoBadge;
                break;
        }
        return {
            textColorInside: `${_textColorInside}`,
            badgeColor: `${_tipoBadge}`,
            textColorOutside: `${_textColorOutside}`
        }
    }

    handleCheck(name, index) {

        this.setState({ listaReenvio: update(this.state.listaReenvio, { [index]: { [name]: { $set: !this.state.listaReenvio[index][name] } } }) })
    }

    changeAllCheckboxes(value) {
        const novaListaSelecionados = this.state.listaReenvio.map(item => {
            return {
                ...item, selecionaItem: value
            }
        })
        this.setState({ listaReenvio: novaListaSelecionados })
    }

    adicionarItemReenvioRemessa() {
        this.setState({ isLoadingAdicionarRemessa: true })
        const listaIdItemReenvio = this.state.listaReenvio.filter(item => item.selecionaItem).map(itemReenvio => {
            return itemReenvio.idItemReenvio
        });

        const body = {
            idItemReenvio: listaIdItemReenvio
        }
        axios.post(this.Configurations.apiBasePath + `/logistica/reenvio/adicionar-itens`, body).then(response => {
            this.setState({
                dados: response.data.dadosMensagem,
                mensagem: response.data.message,
            });
            this.toggleModalSucessoAdicionadoRemessa();
            this.getListaReenvio();
        }).catch(this.handleError).finally(() => this.setState({ isLoadingAdicionarRemessa: false }))
    }


    toggleModalSucessoAdicionadoRemessa() {
        this.setState({ modalSucessoAdicionadoRemessa: !this.state.modalSucessoAdicionadoRemessa })
    }

    render() {

        return (
            <>
                {this.props.shipping && this.state.products.length > 0 && !this.props.flagReenvio && (
                    <div className="row mt-4">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    Produto e edição
                                </div>
                                <div className="card-body">
                                    <Loading show={this.state.isLoadingProducts} />
                                    <div className="row align-items-end">
                                        <div className="col-3">
                                            <div className="form-group m-0">
                                                <label htmlFor="ddlTransportadora">Transportadora</label>
                                                <select id="ddlTransportadora" className="form-control" value={this.state.selectedShippingComp || ''} onChange={this.handleShippingCompChange}>
                                                    <option value=""></option>
                                                    {this.state.shippingCompanies.map((item, index) => {
                                                        return (
                                                            <option key={index} value={item.idTransportadora}>{item.nome}</option>
                                                        )
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <IdProducts
                                                handleProductChange={this.handleProductChange}
                                                produtos={this.state.products}
                                                selectedProduct={this.state.selectedProduct}
                                                idProduto={this.state.idProduto}
                                                nome={this.state.nome}
                                            />
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group m-0">
                                                <label htmlFor="ddlEdicao">Edição</label>
                                                <select id="ddlEdicao" className="form-control" disabled={this.state.productEditions.length === 0} onChange={this.handleEditionChange} value={this.state.selectedEdition || ''} >
                                                    <option value=""></option>
                                                    {this.state.productEditions.map((item, index) => {
                                                        return (
                                                            <option key={index} value={item.numeroEdicao}>{`${item.numeroEdicao} - ${moment(item.dtEntrega).format('DD/MM/YYYY')}`}</option>
                                                        )
                                                    })}

                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-3 text-center">
                                            <div className="form-group m-0">
                                                {this.state.isLoadingItemsToAdd ? (
                                                    <div className="spinner-border text-primary" role="status" />
                                                ) : (
                                                    <button className="btn btn-primary" onClick={this.getSummaryItemsToDeliver}>
                                                        <i className="fas fa-search mr-2"></i>
                                                        Buscar itens
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {this.props.flagReenvio && (
                    <div className='row mt-4'>
                        <div className="col-6 text-left py-3">
                            <button className='btn btn-outline-secondary mr-2' id="checkAll" onClick={() => this.changeAllCheckboxes(true)}>Marcar todas</button>
                            <button className='btn btn-outline-secondary ml-2' id="checkAll" onClick={() => this.changeAllCheckboxes(false)}>Desmarcar todas</button>
                        </div>
                        {this.state.isLoadingAdicionarRemessa ? (
                            <div className='col-6 text-right py-3' >
                                <div className="spinner-border text-primary" role="status" />
                            </div>
                        ) : (
                            <div className="col-6 text-right py-3">
                                <button className='btn btn-outline-primary' onClick={this.adicionarItemReenvioRemessa}>Adicionar à remessa</button>
                            </div>
                        )}
                        <div className='col-12'>
                            <div className='card'>
                                <div className='card-header text-center'>
                                    <p className='m-0'><strong>Reenvios</strong></p>
                                </div>
                                <div className='card-body p-0'>
                                    <ReactTable
                                        data={this.state.listaReenvio}
                                        columns={this.columns}
                                        onFetchData={this.refreshTable}
                                        defaultPageSize={50}
                                        // pages={this.state.pages}
                                        manual
                                        loading={this.state.isLoadingShippingList}
                                        className="-striped -highlight"
                                        headerClassName="ebs-table-header"
                                        previousText="Anterior"
                                        nextText="Próximo"
                                        loadingText="Carregando..."
                                        noDataText="Nenhum item de reenvio encontrado"
                                        pageText='Página'
                                        ofText="de"
                                        rowsText='linhas'
                                    // pageSizeOptions={[5, 10, 25, 50, 100, 200, 300]}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {(this.props.shipping && this.state.itemsToAdd) && (

                    <div className="row mt-4">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    Resumo dos itens a adicionar
                                </div>
                                <div className="card-body">
                                    <Loading show={this.state.isLoadingItemsToAdd} />
                                    <div className="row align-items-center">
                                        <div className="col-6 col-lg-4 text-center border-right">
                                            <strong className="display-4 font-weight-bold">{this.state.itemsToAdd.total}</strong><br />
                                            <span>itens a serem enviados</span>
                                        </div>
                                        <div className="col-6 col-lg-4 text-center border-right">
                                            <strong className="display-4 font-weight-bold">{this.state.itemsToAdd.itensEmOutrasRemessas}</strong><br />
                                            <span>itens já em remessas</span>
                                        </div>
                                        <div className="col-6 col-lg-4 text-center">
                                            <strong className="display-4 font-weight-bold">{this.state.itemsToAdd.totalItensEntregaDireta}</strong><br />
                                            <span>itens para entregas diretas</span>
                                        </div>
                                    </div>
                                    <div className="row">
                                        {this.props.isLoadingAddingItems ? (
                                            <div className="col-12 mt-4 pt-3 text-right border-top">
                                                <div className="spinner-border text-primary" role="status" />
                                            </div>
                                        ) : (
                                            <div className="col-12 mt-4 pt-3 text-right border-top">
                                                <button className="btn btn-primary" onClick={this.props.addToShippingEvent} disabled={this.props.isLoadingAddingItems}>Adicionar à remessa</button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                )}
                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                />
                <Modal isOpen={this.state.modalSucessoAdicionadoRemessa} toggle={this.toggleModalSucessoAdicionadoRemessa}>
                    <ModalHeader toggle={this.toggleModalSucessoAdicionadoRemessa}></ModalHeader>
                    <ModalBody>
                        {this.state.dados.map(item => {
                            return (
                                <div className='row text-center'>
                                    <div className='col-4'>
                                        <p>Remessa: <strong>{item.remessa}</strong></p>
                                    </div>
                                    <div className='col-8'>
                                        <p>Transportadora: <strong>{item.transportadora}</strong></p>
                                    </div>
                                </div>
                            )
                        }
                        )}
                        <div className='col-12 text-center py-2'>
                            <i className='text-success'>{this.state.mensagem}</i>
                        </div>
                    </ModalBody>
                </Modal>
            </>
        )
    }
}

export default ShippingItemsToAdd;
